import "./PropertyInformation.scss";
import { useEffect, useState, useCallback } from "react";

import { ReactComponent as GymIcon } from "assets/icons/gym.svg";
import { ReactComponent as SausageIcon } from "assets/icons/sausage.svg";
import { ReactComponent as PoolIcon } from "assets/icons/pool.svg";
import { ReactComponent as LoadSheddingIcon } from "assets/icons/bolt.svg";
import { ReactComponent as OtherIcon } from "assets/icons/sparkle.svg";
import { ReactComponent as WorkspaceIcon } from "assets/icons/device-laptop.svg";
import { ReactComponent as MicrowaveIcon } from "assets/icons/microwave.svg";
import { ReactComponent as BreadIcon } from "assets/icons/bread.svg";
import { ReactComponent as DishIcon } from "assets/icons/dishes.svg";
import { ReactComponent as KitchenToolsIcon } from "assets/icons/tools-kitchen.svg";
import { ReactComponent as CoffeeIcon } from "assets/icons/coffee.svg";
import { ReactComponent as SockIcon } from "assets/icons/sock.svg";
import { ReactComponent as SunIcon } from "assets/icons/sun-off.svg";
import { ReactComponent as TvIcon } from "assets/icons/tv.svg";
import { ReactComponent as SoundSystemIcon } from "assets/icons/device-speaker.svg";
import { ReactComponent as FirstAidKitIcon } from "assets/icons/first-aid-kit.svg";
import { ReactComponent as BellIcon } from "assets/icons/bell.svg";
import { ReactComponent as FlameIcon } from "assets/icons/flame.svg";

import api from "services/api";

const amenityIcon = {
  barbecue: SausageIcon,
  blender: KitchenToolsIcon,
  coffee_machine: CoffeeIcon,
  designated_workspace: WorkspaceIcon,
  dishwasher: DishIcon,
  gym: GymIcon,
  kettle: KitchenToolsIcon,
  load_shedding_amenities: LoadSheddingIcon,
  microwave: MicrowaveIcon,
  other: OtherIcon,
  swimming_pool: PoolIcon,
  toaster: BreadIcon,
  dryer: SockIcon,
  washing_machine: SockIcon,
  blackout_blinds: SunIcon,
  tv: TvIcon,
  sound_sustem: SoundSystemIcon,
  first_aid_kit: FirstAidKitIcon,
  carbon_monoxide_alarm: BellIcon,
  smoke_alarm: BellIcon,
  fire_extinguisher: FlameIcon,
  sound_system: SoundSystemIcon
};

const categories = {
  bathroom: {
    name: "Bathroom"
  },
  bedroom_and_laundry: {
    name: "Bedroom and laundry"
  },
  entertainment_and_office: {
    name: "Entertainment and office"
  },
  facilities: {
    name: "Facilities"
  },
  heating_and_cooling: {
    name: "Heating and cooling"
  },
  kitchen_and_dining: {
    name: "Kitchen and dining"
  },
  none: {
    name: "Other"
  },
  safety: {
    name: "Safety"
  }
};

export const NewAmenities = ({ propertyId }) => {
  const [amenities, setAmenities] = useState(null);

  const getAmenities = useCallback(() => {
    api
      .get(`/v1/guests/home_info/${propertyId}/amenities`)
      .then(res => {
        setAmenities(res);
      });
  }, [setAmenities, propertyId]);

  useEffect(() => {
    if (!amenities) {
      getAmenities();
    }
  }, [amenities, getAmenities]);

  if (amenities) {
    return (
      <>
        {Object.entries(amenities).map(category => {
          return (
            <li
              className="PropertyInformation__item"
              key={category[0]}
            >
              <span className="PropertyInformation__heading small-header">
                {categories[category[0]]?.name}
              </span>
              <ul>
                {category[1].map(amenity => {
                  const IconComponent =
                    amenityIcon[amenity.key];

                  return (
                    <li
                      key={amenity.key}
                      className="PropertyInformation__amenity"
                    >
                      <span className="PropertyInformation__amenity-text">
                        <IconComponent className="PropertyInformation__amenity-icon" />
                        {amenity.name}
                      </span>
                      <span className="PropertyInformation__text">
                        {amenity.external_notes}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </>
    );
  }

  return null;
};
